import React from 'react'
import Confetti from 'react-confetti'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentRoom2 } from "./ContentRoom2"
import { Balloon } from "./Balloon"
import { Help } from "./Help"

// import { gsap } from "gsap";
import { Clock } from "./Clock"
import "./../assets/scss/Room2.scss";

export const Room2 = (props) => {

  //const app = React.useRef();
  const steps = {
    "b_intro" : ["intro", "close"],
    "f_marge1" : null,
    "b_marge1a": ["centerl", "follow"],
    "b_marge1b": ["centerl", "follow"],
    "b_marge1c": ["centerl", "close"],
    "f_telescopio" : null,
    "b_telescopio": ["full black linked", "close"],
    "f_marge2" : null,
    "b_marge2a": ["centerl", "close"],
    "f_visore" : "",
    "f_marge3" : null,
    "b_marge3a": ["centerl", "close"],
    "f_cellulare" : "",
    "b_cellulare": ["image linked", "close"],
    "risposta1": null,
    "f_marge4" : null, //aperturacassetto1
    "b_marge4a": ["centerl", "follow"],
    "b_marge4b": ["centerl", "close"],
    "f_lettera" : null,
    "b_lettera": ["image link", "close"],
    "f_marge5" : null,//aperturacassetto2
    "b_marge5a": ["centerl", "follow"],
    "b_marge5b": ["centerl", "close"],
    "risposta2" : null,
    "f_marge6" : null,
    "b_marge6a": ["centerl", "follow"],
    "b_marge6b": ["centerl", "close"],
    "f_scatolina" : null,
    "b_scatolina": ["image link", "close"],
    "f_marge7" : null,
    "b_marge7a": ["centerl", "follow"],
    "b_marge7b": ["centerl", "close"],
    "f_cellulare2" : null,
    "b_cellulare2" : ["slide link", "close"],
    "f_collana" : null,
    "risposta3" : null,
    "b_exit" : ["exit", ""]
  };

  React.useEffect(() => {
    if(props.step == Object.keys(steps).indexOf("risposta1")) props.onNextHelp(1);
    if(props.step == (Object.keys(steps).indexOf("risposta1") + 1)) props.onNextHelp(0);
    if(props.step == Object.keys(steps).indexOf("risposta2")) props.onNextHelp(4);
    if(props.step == (Object.keys(steps).indexOf("risposta2") + 1)) props.onNextHelp(0);
    if(props.step == Object.keys(steps).indexOf("risposta3")) props.onNextHelp(7);
  }, [props.step]);

  const handleLinkVisore = () => {
    window.open('http://www.brera.inaf.it/PanoramicheBrera/cupola_Schiaparelli/app-files/', '_blank', 'noopener,noreferrer');
    props.onChangeStep(Object.keys(steps).indexOf("f_marge3"));
  }

  const handleLinkCellulare = () => {
    window.open('http://heavens-above.com/skychart2.aspx', '_blank', 'noopener,noreferrer');
    props.onChangeStep(Object.keys(steps).indexOf("f_collana"));
  }

  const handleLinkCollana = () => {
    window.open('https://escapemarte.museoscienza.it/schiaparelli/', '_blank', 'noopener,noreferrer');
    props.onChangeStep(Object.keys(steps).indexOf("risposta3"));
  }

    return(
        <div className="room2">
        {1===0 && <Confetti />}

            <div className="parete">
              <div className="centroParete">
                <div className="cornice up"></div>
                <div className="centroCentroParete">
                  <div className="nuvola nuvola1"><ContentRoom2 stringToRet="nuvola" /></div>
                  <div className="nuvola nuvola2"><ContentRoom2 stringToRet="nuvola" /></div>
                  <div className="nuvola nuvola3"><ContentRoom2 stringToRet="nuvola" /></div>
                  <div className="nuvola nuvola4"><ContentRoom2 stringToRet="nuvola" /></div>
                  <div className="nuvola nuvola5"><ContentRoom2 stringToRet="nuvola" /></div>
                  <div className="pareteBlock single"></div>
                  <div className="pareteBlock window win1">
                    <div className="corniceVert"></div>
                    <div className="corniceOriz"></div>
                  </div>
                  <div className="pareteBlock double"></div>
                  <div className="pareteBlock window win2">
                    <div className="corniceVert"></div>
                    <div className="corniceOriz"></div>
                  </div>
                  <div className="pareteBlock double">
                    <div className='orologio'>
                      <Clock />
                    </div>
                  </div>
                  <div className="pareteBlock window win3">
                    <div className="corniceVert"></div>
                    <div className="corniceOriz"></div>
                  </div>
                  <div className="pareteBlock single"></div>
                </div>
                <div className="cornice down"></div>
              </div>
            </div>

            <div className="pavimento">
              <div className="texture"></div>
            </div>

            <div className="areaSecretaire">
              <div className={`cassettoup ${(props.step >= Object.keys(steps).indexOf("f_marge4") && props.step <= Object.keys(steps).indexOf("risposta2")) ? "open" : ""}`}>
                <div className="frontale">
                  <div className="maniglia"></div>
                </div>
                <div className="fondo">
                  <div className="angle"></div>
                  <button className={`letterac ${(props.step >= Object.keys(steps).indexOf("f_lettera")) ? "active" : "unactive"}`}
                          onClick={() => props.step >= Object.keys(steps).indexOf("f_lettera") ? props.onChangeStep(Object.keys(steps).indexOf("b_lettera")) : false } >
                    {(props.step == Object.keys(steps).indexOf("f_lettera")) &&
                      <CommonSvgContent stringToRet="click" />
                    }
                    {(props.step > Object.keys(steps).indexOf("f_lettera") && props.step <= Object.keys(steps).indexOf("risposta2")) &&
                      <div className="clickable" />
                    }
                    <ContentRoom2 stringToRet="letterac" />
                   </button>
                </div>
              </div>

              <div className={`cassettodown ${(props.step >= Object.keys(steps).indexOf("f_marge5") && props.step <= Object.keys(steps).indexOf("risposta3")) ? "open" : ""}`}>
                <div className="frontale">
                  <div className="maniglia"></div>
                </div>
                <div className="fondo">
                  <button className={`scatolina ${(props.step >= Object.keys(steps).indexOf("f_scatolina")) ? "active" : "unactive"}`}
                          onClick={() => props.step >= Object.keys(steps).indexOf("f_scatolina") ? props.onChangeStep(Object.keys(steps).indexOf("b_scatolina")) : false } >
                    {(props.step == Object.keys(steps).indexOf("f_scatolina")) &&
                      <CommonSvgContent stringToRet="click" />
                    }

                    {(props.step > Object.keys(steps).indexOf("f_scatolina") && props.step <= Object.keys(steps).indexOf("risposta3")) &&
                      <div className="clickable" />
                    }
                    <ContentRoom2 stringToRet="scatolina" />
                  </button>
                </div>
              </div>

              <div className="piano">
                  <button className={`visore ${(props.step >= Object.keys(steps).indexOf("f_visore") &&  props.step <= Object.keys(steps).indexOf("risposta1")) ? "active" : "unactive"}`}
                          onClick={props.step >= Object.keys(steps).indexOf("f_visore") &&  props.step <= Object.keys(steps).indexOf("risposta1") ? handleLinkVisore : () => false } >
                    {(props.step == Object.keys(steps).indexOf("f_visore")) &&
                      <CommonSvgContent stringToRet="click" />
                    }
                    {(props.step > Object.keys(steps).indexOf("f_visore") && props.step <= Object.keys(steps).indexOf("risposta1")) &&
                      <div className="clickable" />
                    }
                    <CommonSvgContent stringToRet="visore" />
                 </button>

                 <button
                   className={`phone ${(props.step >= Object.keys(steps).indexOf("f_cellulare") && props.step <= Object.keys(steps).indexOf("risposta1")) ? "active" :
                                       (props.step >= Object.keys(steps).indexOf("f_cellulare2") && props.step <= Object.keys(steps).indexOf("risposta3")) ? "active" : "unactive"}`}
                   onClick={props.step >= Object.keys(steps).indexOf("f_cellulare") &&  props.step <= Object.keys(steps).indexOf("risposta1") ? () => props.onChangeStep(Object.keys(steps).indexOf("b_cellulare")) :
                            props.step >= Object.keys(steps).indexOf("f_cellulare2") &&  props.step <= Object.keys(steps).indexOf("risposta3") ? handleLinkCellulare : () => false} >
                   {(props.step == Object.keys(steps).indexOf("f_cellulare") ||
                     props.step == Object.keys(steps).indexOf("f_cellulare2")) &&
                     <CommonSvgContent stringToRet="click" />
                   }

                   {(props.step > Object.keys(steps).indexOf("f_cellulare") && props.step <= Object.keys(steps).indexOf("risposta1") ||
                     props.step > Object.keys(steps).indexOf("f_cellulare2") && props.step <= Object.keys(steps).indexOf("risposta3")) &&
                     <div className="clickable" />
                   }


                   <CommonSvgContent stringToRet="phone" />
                </button>


                <button className={`collana ${(props.step >= Object.keys(steps).indexOf("f_collana") &&  props.step <= Object.keys(steps).indexOf("risposta3")) ? "active" : "unactive"}`}
                        onClick={props.step >= Object.keys(steps).indexOf("f_collana") &&  props.step <= Object.keys(steps).indexOf("risposta3") ? handleLinkCollana : () => false } >
                  {(props.step == Object.keys(steps).indexOf("f_collana")) &&
                    <CommonSvgContent stringToRet="click" />
                  }
                  {(props.step > Object.keys(steps).indexOf("f_collana") && props.step <= Object.keys(steps).indexOf("risposta3")) &&
                    <div className="clickable" />
                  }
                  <ContentRoom2 stringToRet="collana" />
               </button>


              </div>
              <div className="cornice"></div>
              <div className="gambadx"></div>
              <div className="gambasx"></div>
            </div>

            <div className="scala">
              <ContentRoom2 stringToRet="scala" />
            </div>

            <button className={`telescopio ${(props.step >= Object.keys(steps).indexOf("f_telescopio") &&  props.step <= Object.keys(steps).indexOf("risposta1")) ? "active" : "unactive"}`}
                    onClick={() => props.step >= Object.keys(steps).indexOf("f_telescopio") &&  props.step <= Object.keys(steps).indexOf("risposta1") ? props.onChangeStep(Object.keys(steps).indexOf("b_telescopio")) : false } >
              {(props.step == Object.keys(steps).indexOf("f_telescopio")) &&
                <CommonSvgContent stringToRet="click" />
              }
              {(props.step > Object.keys(steps).indexOf("f_telescopio") && props.step <= Object.keys(steps).indexOf("risposta1")) &&
                <div className="clickable" />
              }
              <ContentRoom2 stringToRet="telescopio" />
            </button>

            <div className={`areaTelefono ${(props.step == Object.keys(steps).indexOf("risposta1") || props.step == Object.keys(steps).indexOf("risposta2") || props.step == Object.keys(steps).indexOf("risposta3")) ? "help3 ringing" : ""}`}>
              <div className="pianoUnder" />
              <div className="pianoOver">
                <div className="telefono">
                  <CommonSvgContent stringToRet="telefono" />
                </div>

                <div className="helpsWrapper">
                  <div className="helps">
                    <button className="helpclick1 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 1) :
                                                                          (props.helpstate >= 4 && props.helpstate <= 6) ? props.onAskForHelp(e, 4) :
                                                                          (props.helpstate >= 7 && props.helpstate <= 9) ? props.onAskForHelp(e, 7) : false }>1</button>
                    <button className="helpclick2 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 2) :
                                                                          (props.helpstate >= 4 && props.helpstate <= 6) ? props.onAskForHelp(e, 5) :
                                                                          (props.helpstate >= 7 && props.helpstate <= 9) ? props.onAskForHelp(e, 8) : false }>2</button>
                    <button className="helpclick3 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 3) :
                                                                          (props.helpstate >= 4 && props.helpstate <= 6) ? props.onAskForHelp(e, 6) :
                                                                          (props.helpstate >= 7 && props.helpstate <= 9) ? props.onAskForHelp(e, 9) : false }>3</button>
                  </div>
                </div>
              </div>
            </div>

            {(props.step == Object.keys(steps).indexOf("risposta1")) &&
              <div className="risposta">
                {(props.answerfeedback == "wrong") && (<div className="wrong"><p>La password non è corretta</p></div>)}
                {(props.answerfeedback == "right") && (
                  <>
                    <p>BEN FATTO! Hai risolto l'enigma</p>
                    <Confetti />
                  </>
                )}
                {(props.answerfeedback !== "right") && (
                  <div className="rispostaCont">
                    <form onSubmit={(e) => props.onSubmitAnswer(e, "room2a", Object.keys(steps).indexOf("risposta1"))}>
                      <input type="text" placeholder="" value={props.answer} onChange={(e) => props.onChangeAnswer(e)} />
                      <input type="submit" value="OK" />
                    </form>
                    <p>20 caratteri senza spazi</p>
                  </div>
                )}
              </div>
            }

            {(props.step == Object.keys(steps).indexOf("risposta2")) &&
              <div className="risposta">
                {(props.answerfeedback == "wrong") && (<div className="wrong"><p>La password non è corretta</p></div>)}
                {(props.answerfeedback == "right") && (
                  <>
                    <p>BEN FATTO! Hai risolto l'enigma</p>
                    <Confetti />
                  </>
                )}
                {(props.answerfeedback !== "right") && (
                  <div className="rispostaCont">
                    <form onSubmit={(e) => props.onSubmitAnswer(e, "room2b", Object.keys(steps).indexOf("risposta2"))}>
                      <input type="text" placeholder="" value={props.answer} onChange={(e) => props.onChangeAnswer(e)} />
                      <input type="submit" value="OK" />
                    </form>
                    <p>4 caratteri senza spazi</p>
                  </div>
                )}
              </div>
            }

            {(props.step == Object.keys(steps).indexOf("risposta3")) &&
              <div className="risposta">
                {(props.answerfeedback == "wrong") && (<div className="wrong"><p>La password non è corretta</p></div>)}

                <div className="rispostaCont">
                  <form onSubmit={(e) => props.onSubmitAnswer(e, "room2c", Object.keys(steps).indexOf("risposta3"))}>
                    <input type="text" placeholder="" value={props.answer} onChange={(e) => props.onChangeAnswer(e)} />
                    <input type="submit" value="OK" />
                  </form>
                  <p>20 caratteri senza spazi</p>
                </div>
              </div>
            }

            <button
              className={`marge ${(props.step >= Object.keys(steps).indexOf("f_marge1")) ? "active" : "unactive"}`}
              onClick={() => props.step >= Object.keys(steps).indexOf("f_marge1") && props.step < Object.keys(steps).indexOf("f_marge2") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge1a")) :
                             props.step >= Object.keys(steps).indexOf("f_marge2") && props.step < Object.keys(steps).indexOf("f_marge3") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge2a")) :
                             props.step >= Object.keys(steps).indexOf("f_marge3") && props.step < Object.keys(steps).indexOf("risposta1") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge3a")) :
                             props.step == Object.keys(steps).indexOf("risposta1") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge1b")) :
                             props.step >= Object.keys(steps).indexOf("f_marge4") && props.step < Object.keys(steps).indexOf("f_marge5") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge4a")) :
                             props.step >= Object.keys(steps).indexOf("f_marge5") && props.step < Object.keys(steps).indexOf("f_marge6") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge5a")) :
                             props.step >= Object.keys(steps).indexOf("f_marge6") && props.step < Object.keys(steps).indexOf("f_marge7") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge6a")) :
                             props.step == Object.keys(steps).indexOf("f_marge7")  ? props.onChangeStep(Object.keys(steps).indexOf("b_marge7a")) :
                             props.step >= Object.keys(steps).indexOf("b_marge7b") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge7b")) : false } >
              {(props.step == Object.keys(steps).indexOf("f_marge1") ||
                props.step == Object.keys(steps).indexOf("f_marge2") ||
                props.step == Object.keys(steps).indexOf("f_marge3") ||
                props.step == Object.keys(steps).indexOf("f_marge4") ||
                props.step == Object.keys(steps).indexOf("f_marge5") ||
                props.step == Object.keys(steps).indexOf("f_marge6") ||
                props.step == Object.keys(steps).indexOf("f_marge7")) &&
                <CommonSvgContent stringToRet="click" />
              }

              {(props.step > Object.keys(steps).indexOf("f_marge1") && props.step < Object.keys(steps).indexOf("f_marge2") ||
                props.step > Object.keys(steps).indexOf("f_marge2") && props.step < Object.keys(steps).indexOf("f_marge3") ||
                props.step > Object.keys(steps).indexOf("f_marge3") && props.step <= Object.keys(steps).indexOf("risposta1") ||
                props.step > Object.keys(steps).indexOf("f_marge4") && props.step < Object.keys(steps).indexOf("f_marge5") ||
                props.step > Object.keys(steps).indexOf("f_marge5") && props.step <= Object.keys(steps).indexOf("risposta2") ||
                props.step > Object.keys(steps).indexOf("f_marge6") && props.step < Object.keys(steps).indexOf("f_marge7") ||
                props.step > Object.keys(steps).indexOf("f_marge7") && props.step <= Object.keys(steps).indexOf("risposta3")) &&
                <div className="clickable" />
              }

              <CommonSvgContent stringToRet="marge" />
            </button>


            {(props.helpopen != 0) &&
              <Help room={props.room} clickon={`help${props.helpopen}`} onNextHelp={props.onNextHelp} />
            }

            {(Object.keys(steps).length > props.stepnow && Object.keys(steps)[props.stepnow].startsWith("b_")) &&
              <Balloon type={steps[Object.keys(steps)[props.stepnow]][0]} room={props.room} clickon={Object.keys(steps)[props.stepnow]} button={steps[Object.keys(steps)[props.stepnow]][1]} interaction={false} onChangeStep={props.onChangeStep} onChangeStep={props.onChangeStep} onChangeRoom={props.onChangeRoom} />
            }

        </div>
    )
}
